import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Grid } from '@material-ui/core';

import moment from 'moment';

import FormContainer from '../../../../components/FormContainer';
import Accordion from '../../../../components/Accordion';
import Select from '../../../../components/Inputs/Select';
import Input from '../../../../components/Inputs/Input';
import Radio from '../../../../components/Inputs/Radio';
import StepProgress from '../../../../components/StepProgress';
import DatepickerMui from '../../../../components/Inputs/DatepickerMui';
import CardDocument from '../../../../components/Cards/Document';
import FileViewer from '../../../../components/FileViewer';
import Alert from '../../../../components/Alert';
import PageLoader from '../../../../components/PageLoader';

import Modal from '../../../../components/Modal';
import Button from '../../../../components/Button';
import validators from '../../../../utils/defaultValidators';
import validate from '../../../../utils/validateForm';

import { useGlobal } from '../../../../contexts/Global/context';

import {
    getEnderecoByCep,
    getMunicipios,
    alterarBeneficiario,
    getCongenerByContractAndPlanAndUfAndCity,
    getStates,
    getCities,
} from '../../../../services';
import { getCongenerByContractAndPlan } from '../../../../services/v3/contrato-congenere';

import { base64toBlob, cloneObject, handleTopCritics, addTimeToNameFile, checkIsSupport } from '../../../../utils';
import steps from '../../../../utils/steps.json';

import translateToSchema from './translate';
import schema from './schema';

import { PageContainer, ContainerButton } from '../../../../styles/styles';

import * as S from './styles';
import { EmptyField } from '../../../../components/Inputs/styles';
import regexps from '../../../../utils/regexps';

function Titular({ location: { dataBeneficiario, criticas = [] } }) {
    const history = useHistory();

    const { dataActiveContract, staticOptions, setShowSupportModal } = useGlobal();

    const translatedData = dataBeneficiario && translateToSchema(dataBeneficiario);

    const [dataForm, setDataForm] = useState(translatedData ? cloneObject(translatedData) : cloneObject(schema));
    const [loadingPost, setLoadingPost] = useState(false);
    const [alerts, setAlerts] = useState(criticas);
    const [dataMovimentacao, setDataMovimentacao] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [modalInfo, setModalInfo] = useState({});
    const [othersDocuments, setOthersDocuments] = useState([]);
    const [cpfLoading] = useState(false);
    const [cepLoading, setCepLoading] = useState(false);
    const [otherDocumentsRequired, setOtherDocumentsRequired] = useState(false);
    const [countFieldsChanged, setCountFieldsChanged] = useState(0);
    const [pageLoading, setPageLoading] = useState(false);
    const [congenerContract, setCongenerContract] = useState([]);
    const [adressAux, setadressAux] = useState(false);

    function mapStateOptions(results) {
        return results.map(({ descricaoUf, idUf }) => ({
            codigo: idUf,
            nome: descricaoUf,
        }));
    }

    function mapCityOptions(results) {
        return results.map(({ descricaoMunicipio, idMunicipio }) => ({
            codigo: idMunicipio,
            nome: descricaoMunicipio,
        }));
    }

    async function getCongenereStates(contracts = congenerContract || []) {
        const states = new Set();

        await Promise.all(
            contracts.map(async ({ numeroContratoCongenere }) => {
                const { congenere } = await getStates({ idContratoCongenere: numeroContratoCongenere });
                if (congenere?.estados) {
                    congenere.estados.forEach((estado) => {
                        states.add(JSON.stringify(estado));
                    });
                }
            })
        );
        return Array.from(states)
            .map((state) => JSON.parse(state))
            .flat();
    }

    async function getCongenereCities(idUf, contracts = congenerContract || []) {
        const cities = new Set();

        await Promise.all(
            contracts.map(async ({ numeroContratoCongenere }) => {
                const { congenere } = await getCities({ idContratoCongenere: numeroContratoCongenere, idUf });
                if (congenere?.municipios) {
                    congenere.municipios.forEach((municipio) => {
                        cities.add(JSON.stringify(municipio));
                    });
                }
            })
        );
        return Array.from(cities)
            .map((city) => JSON.parse(city))
            .flat();
    }

    async function handleChangeState(state) {
        const municipios = (await getMunicipios(state)) || [];

        return municipios;
    }

    async function handleChangeCep(event) {
        const { value, unmaskedValue } = event;

        setCepLoading(true);
        let foundCep = true;
        const response = await getEnderecoByCep(unmaskedValue);

        // Para zerar o endereço caso seja digitado um cep inválido
        if (!response) {
            setadressAux(true);
            foundCep = false;
        }

        const address = response;

        const dataAddress = {
            address: {
                ...dataForm.address,
                value: address.tipoLogradouro ? `${address?.tipoLogradouro}. ${address?.logradouro}` : '',
            },
            hood: { ...dataForm.hood, value: address ? address?.estado?.municipios[0].bairros[0].nome : '' },
            uf: {
                ...dataForm.uf,
                value: address ? address?.estado?.sigla : '',
                lookup: address ? address?.estado?.nome : '',
            },
            city: {
                ...dataForm.city,
                value: address ? address?.estado?.municipios[0].codigo : '',
                lookup: address ? address?.estado?.municipios[0].nome : '',
            },
            cep: {
                ...dataForm.cep,
                unmaskedValue,
                value,
                error: !foundCep && 'Os dados de endereço não foram localizados a partir do CEP informado',
            },
        };

        if (foundCep) {
            dataAddress.address.error = '';
            dataAddress.hood.error = '';
            dataAddress.uf.error = '';
            dataAddress.city.error = '';
        }

        setCepLoading(false);

        return adressAux ? false : dataAddress;
    }

    function checkOtherDocumentsRequired(key, newDataForm) {
        const fullnameChanged = newDataForm.fullName.value !== translatedData.fullName.value;

        const birthChanged =
            moment(newDataForm.birth.value).format('DD/MM/YYYY') !==
            moment(translatedData.birth.value).format('DD/MM/YYYY');

        const cpfChanged = newDataForm.cpf.value !== translatedData.cpf.value;

        const admissionChanged = (newDataForm.admissionDate.value || '') !== translatedData.admissionDate.value;

        const changedSpecificField = ['fullName', 'birth', 'cpf', 'admissionDate'].includes(key);

        const fieldsChanged = [fullnameChanged, birthChanged, cpfChanged, admissionChanged];

        setCountFieldsChanged(fieldsChanged.filter((changed) => changed).length);

        setOtherDocumentsRequired(changedSpecificField && fieldsChanged.some((changed) => changed));
    }

    function handleInputBlur(event) {
        const { id, name, value } = event.target;
        const key = id || name;

        const form = cloneObject(dataForm);

        // Valida as regras de negocio do campo e, caso haja erro, altera o indice error
        if (typeof validators[key] === 'function') validators[key](form);

        if (key === 'admissionDate') {
            form.birth.error = '';

            if (form.birth.value) validators.birth(form);
        }

        if (key === 'birth') {
            form.admissionDate.error = '';
            form.dn.error = '';

            if (form.admissionDate.value) validators.admissionDate(form);
            if (form.dn.value) validators.dn(form);
        }

        // Valida as regras de negocio do campo e, caso haja erro, altera o indice error
        if (typeof validators[key] === 'function') validators[key](form);

        // Valida os campos obrigatorios sem valores
        if (form[key].required && !value) {
            form[key].error = form[key].requiredMessage || 'Preencha com um valor válido.';
        }

        setDataForm({ ...form });
    }

    async function handleChangeInput(event) {
        const { id, value, unmaskedValue, lookup, ...rest } = event;

        let field = { ...dataForm[id], value, lookup, unmaskedValue, error: '', ...rest };

        let dynamicFields = {};

        const city = { ...dataForm.city };

        if (id === 'uf') {
            const municipios = await handleChangeState(value);

            city.options = municipios;
            city.value = '';
            city.lookup = '';
        }

        let dataAddress = {};

        if (id === 'cep' && unmaskedValue.length === 8 && unmaskedValue !== dataForm.cep.value) {
            dataAddress = (await handleChangeCep(event)) || {};

            if (dataAddress.uf.value) {
                document.getElementById('addressNumber').focus();
            }

            const municipios = await handleChangeState(dataAddress.uf.value);

            dataAddress.city.options = municipios;

            field = dataAddress.cep;
        }

        if (id === 'stateService') {
            const municipios = value ? await getCongenereCities(value) : [];

            const countyService = cloneObject(dataForm.countyService);

            countyService.options = mapCityOptions(municipios);
            countyService.value = '';
            countyService.lookup = '';

            dynamicFields = { ...dynamicFields, countyService };
        }

        const newDataForm = {
            ...dataForm,
            city,
            ...dynamicFields,
            ...dataAddress,
            [id]: field,
        };

        checkOtherDocumentsRequired(id, newDataForm);

        setDataForm(newDataForm);
    }

    function handleShowModal(file) {
        const extArquivo = file.name.split('.')[1];

        const mode = ['jpeg', 'jpg', 'png', 'svg'].includes(extArquivo.toLowerCase()) ? 'image' : 'application';

        const blob = base64toBlob(file.base64, `${mode}/${extArquivo}`);
        const blobUrl = URL.createObjectURL(blob);

        setModalInfo({
            title: file.name,
            content: <FileViewer fileExtension={extArquivo} src={blobUrl} base64={file.base64} />,
        });

        setShowModal(true);
    }

    function handleFileChange({ event, id }) {
        if (!event.target.files) return;

        const reader = new FileReader();
        const file = event.target.files[0];

        reader.onloadend = () => {
            const { name: fileName, size: fileSize } = file;

            const fileNameFiltered = fileName.replace(regexps.charRemove, '');

            const base64 = reader.result.split(',')[1];

            // Limpa o input de arquivo para
            // eslint-disable-next-line no-param-reassign
            event.target.value = null;

            const acceptedFormats = ['jpeg', 'jpg', 'png', 'pdf', 'svg'];

            const fileExtention = fileNameFiltered.substring(fileNameFiltered.lastIndexOf('.') + 1);
            if (!acceptedFormats.includes(fileExtention.toLowerCase())) return;

            const dataDocument = {
                id,
                base64,
                name: addTimeToNameFile(fileNameFiltered, fileExtention),
                size: `${(fileSize / 1024).toFixed(2)}Kb`,
            };

            const documents = cloneObject(othersDocuments);

            const foundDocument = documents.filter(
                (document) => document.id === id && document.name === fileNameFiltered
            );
            if (foundDocument.length) return;

            documents.push(dataDocument);

            setOthersDocuments([...documents]);
        };

        reader.readAsDataURL(file);
    }

    function handleFileDelete({ id, fileName }) {
        let documents = cloneObject(othersDocuments);

        documents = documents.filter((document) => document.id === id && document.name !== fileName);

        setOthersDocuments([...documents]);
    }

    async function handleSendDataTitular() {
        const { validatedForm, isValid } = validate(dataForm);

        setDataForm({
            ...dataForm,
            ...validatedForm,
        });

        if (!isValid) {
            setTimeout(() => {
                const firstElementWithError = document.querySelector('.error');

                if (firstElementWithError) {
                    firstElementWithError.scrollIntoView({ block: 'center', behavior: 'smooth' });
                }
            }, 100);

            setLoadingPost(false);

            return;
        }

        if (checkIsSupport()) {
            setShowSupportModal(true);
            return;
        }

        setLoadingPost(true);

        const [ddd, cellphone] = dataForm.cellphone.value.replace(/\(|\)/g, '').split(' ');

        const payload = {
            ...dataMovimentacao,
            numeroContrato: dataBeneficiario.contrato.numero,
            numeroAssociadoOuNumeroCarteira: dataBeneficiario.numCarteira,
            numeroSequencialMatricula: dataForm.enrollmentSequence.value,
            nomeAssociado: dataForm.fullName.value,
            numeroCPF: dataForm.cpf.unmaskedValue,
            tipoAssociado: 'T',
            nomeSocial: dataForm.socialName.value,
            dataNascimento: dataForm.birth.value,
            sexo: dataForm.gender.value,
            nomeMae: dataForm.motherName.value,
            numeroUnicoSaude: dataForm.sus.value && dataForm.sus.value.replace(/\s/g, ''),
            codigoPlano: dataBeneficiario.plano.planoSaude,
            codigoLotacaoTS: +dataBeneficiario.lotacao.codigoTs,
            codigoLotacao: dataForm.capacity.value,
            codigoLocalTrabalho: dataForm.costCenter.value,
            dtInicioContribuicao: dataForm.startDate.value,
            nomeLogradouro: dataForm.address.value,
            numeroCEP: dataForm.cep.unmaskedValue,
            numeroEndereco: dataForm.addressNumber.value,
            complementoEndereco: dataForm.complement.value,
            nomeBairro: dataForm.hood.value,
            siglaUF: dataForm.uf.value,
            codigoMunicipio: dataForm.city.value,
            codigoMunicipioAtendimento: dataForm.countyService.value,
            dddCelular: ddd,
            numeroCelular: cellphone,
            enderecoEmail: dataForm.email.value,
            estadoCivil: dataForm.civilState.value.toString(),
            nacionalidade: dataForm.nationality.value,
            situacaoNaEmpresa: +dataForm.functionalStatus.value,
            dataAdmissao: dataForm.admissionDate.value,
            numeroMatriculaNaEmpresa: dataForm.functionalEnrollment.value,
            dataLotacao: dataForm.startCapacity.value || null,
            numeroPIS: dataForm.pis.unmaskedValue,
            numeroDeclaracaoNascidoVivo: dataForm.dn.value,
            codigoCargo: dataForm.occupation.value,
            anexos: othersDocuments.map((doc) => ({ NomeArquivo: doc.name, Base64Arquivo: doc.base64 })),
            referenciaMovimentacao: dataActiveContract.referenciaMovimentacao?.dataReferenciaMovimentacao,
        };

        const response = await alterarBeneficiario(payload);

        if (response.errorDescription) {
            response.movimentacoes = [
                {
                    criticas: [
                        {
                            tipo: 1,
                            descricao: response.errorDescription,
                            codigo: '#API_ERROR',
                        },
                    ],
                },
            ];
        }

        const movimentacao = response?.movimentacoes[0] || {};

        const handledAlerts = handleTopCritics(movimentacao.criticas);

        if (handledAlerts?.length > 0) {
            setAlerts([...handledAlerts]);

            setDataMovimentacao({
                sequencialMovimentacao: movimentacao.sequencialMovimentacao,
                codigoSituacaoMovimentacao: movimentacao.codigoSituacaoMovimentacao,
            });

            setTimeout(() => {
                window.document.getElementById('page-content').scrollTo(0, 0);
            }, 100);

            setLoadingPost(false);

            return;
        }

        history.push('/movimentacao_cadastral/validar_alteracao_beneficiario');
    }

    async function updateCongenerName() {
        if (!dataForm.stateService?.value || !dataForm.countyService?.value) {
            return;
        }

        const congenerName = cloneObject(dataForm.congenerName);
        const { results } =
            (await getCongenerByContractAndPlanAndUfAndCity({
                numeroContrato: dataActiveContract?.numero,
                codigoPlano: dataBeneficiario?.plano.planoSaude,
                siglaUf: dataForm?.stateService.value,
                codigoMunicipio: dataForm?.countyService.value,
            })) || [];

        if (results && results[0]) {
            congenerName.value = results[0]?.nomeFantasiaCongenere || '';
            setDataForm({ ...dataForm, congenerName });
        }
    }

    useEffect(() => {
        setDataForm({ ...dataForm, congenerName: { ...dataForm.congenerName, value: '' } });

        if (dataForm?.stateService.value && dataForm?.countyService.value) updateCongenerName();
    }, [dataForm?.stateService.value, dataForm?.countyService.value]);

    useEffect(() => {
        if (!dataBeneficiario) history.push('/movimentacao_cadastral/selecionar_alterar_beneficiario');

        async function loadDataContrato() {
            setPageLoading(true);

            const {
                isPj,
                isPme,
                isAdesao,
                numero,
                lotacoes,
                obrigaInformarLotacao,
                parametros,
                funcoes,
                centrosCusto,
            } = dataActiveContract;

            const { results: congenerContractsList } = await getCongenerByContractAndPlan({
                numeroContrato: numero,
                codigoPlano: dataBeneficiario?.plano.planoSaude,
            });

            setCongenerContract(congenerContractsList);

            const stateOptions = await getCongenereStates(congenerContractsList);

            const congenerUf = dataBeneficiario?.enderecos[0]?.ufAtendimento;

            const municipiosCongenere = congenerUf ? await getCongenereCities(congenerUf, congenerContractsList) : [];

            const municipios = await handleChangeState(dataForm.uf.value);

            let results;

            if (
                dataBeneficiario?.enderecos[0]?.ufAtendimento &&
                dataBeneficiario?.enderecos[0]?.codigoMunicipioAtendimento
            ) {
                results = await getCongenerByContractAndPlanAndUfAndCity({
                    numeroContrato: numero,
                    codigoPlano: dataBeneficiario?.plano.planoSaude,
                    siglaUf: dataBeneficiario?.enderecos[0]?.ufAtendimento,
                    codigoMunicipio: dataBeneficiario?.enderecos[0]?.codigoMunicipioAtendimento,
                });
            } else {
                results = await getCongenerByContractAndPlan({
                    numeroContrato: numero,
                    codigoPlano: dataBeneficiario?.plano.planoSaude,
                });
            }

            if (results?.results?.length) results = results.results;

            const [dataCongener] = results.length ? results : [{}];

            let initialValues = {};

            if (isPme) {
                initialValues = {
                    ...initialValues,
                    costCenter: { ...dataForm.costCenter, required: !isPme, error: '' },
                };
            }

            initialValues = {
                ...initialValues,
                cellphone: {
                    ...dataForm.cellphone,
                    required: isAdesao || isPme,
                },
                email: {
                    ...dataForm.email,
                    required: isAdesao || isPme,
                },
                civilState: { ...dataForm.civilState, options: staticOptions.estadoCivil },
                functionalEnrollment: {
                    ...dataForm.functionalEnrollment,
                    required: parametros.obrigatorioInformarMatriculaFuncional,
                    error: '',
                },
                functionalStatus: { ...dataForm.functionalStatus, options: staticOptions.situacaoEmpresa },
                enrollmentSequence: {
                    ...dataForm.enrollmentSequence,
                    required: parametros.obrigatorioInformarSequencialMatriculaFuncional,
                    error: '',
                },
                occupation: {
                    ...dataForm.occupation,
                    required: isPj,
                    options: funcoes,
                    error: '',
                },
                capacity: {
                    ...dataForm.capacity,
                    required: obrigaInformarLotacao,
                    options: lotacoes,
                    error: '',
                },
                startCapacity: {
                    ...dataForm.startCapacity,
                    required: obrigaInformarLotacao,
                    error: '',
                },
                costCenter: { ...dataForm.costCenter, options: centrosCusto },
                uf: { ...dataForm.uf, options: staticOptions.estados },
                city: { ...dataForm.city, options: municipios },
                stateService: {
                    ...dataForm.stateService,
                    options: mapStateOptions(stateOptions),
                },
                countyService: {
                    ...dataForm.countyService,
                    options: mapCityOptions(municipiosCongenere),
                },
                congenerName: {
                    ...dataForm.congenerName,
                    value: dataCongener?.nomeFantasiaCongenere,
                },
            };

            setDataForm({
                ...dataForm,
                ...initialValues,
            });
            setPageLoading(false);
        }
        loadDataContrato();
    }, []);

    return (
        <PageContainer>
            <StepProgress steps={steps.alterarBeneficiario} activeStep={2} />

            <S.AlertGroup>
                {alerts.map((alert) => (
                    <Alert
                        key={alert.descricao}
                        type={alert.tipo}
                        title={alert.descricao}
                        message={alert.complemento}
                    />
                ))}
            </S.AlertGroup>

            <Accordion title="Dados do plano">
                <FormContainer>
                    <Input
                        field={{
                            id: 'healthPlan',
                            label: dataActiveContract.isDental ? 'Plano Dental' : 'Plano de saúde',
                            value: `${dataBeneficiario?.plano.planoSaude} - ${dataBeneficiario?.plano.nome}`,
                            disabled: true,
                        }}
                    />
                    <Input
                        field={{
                            id: 'dateStartPlan',
                            label: 'Data de início do plano',
                            help: 'Data sugerida pelo sistema. Alterar a data de início gera cobrança do valor integral do plano na próxima fatura.',
                            value:
                                dataBeneficiario?.plano.dataInicio &&
                                moment(dataBeneficiario?.plano.dataInicio, 'MM/DD/YYYY h:mm:ss').format('DD/MM/YYYY'),
                            disabled: true,
                        }}
                    />
                    <Select field={dataForm.stateService} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Select
                        field={{
                            ...dataForm.countyService,
                            disabled: !dataForm.stateService.value && !dataForm.countyService.value,
                        }}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />
                    {dataForm.congenerName.value && <Input field={dataForm.congenerName} />}
                </FormContainer>
            </Accordion>

            <Accordion title="Dados profissionais">
                <FormContainer>
                    <Select field={dataForm.occupation} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Select field={dataForm.functionalStatus} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <DatepickerMui
                        field={dataForm.admissionDate}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />
                    <Input
                        field={dataForm.functionalEnrollment}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />
                    <Input field={dataForm.enrollmentSequence} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <DatepickerMui
                        field={dataForm.startCapacity}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />
                    <Select field={dataForm.capacity} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    {!dataActiveContract.isPme && (
                        <Select field={dataForm.costCenter} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    )}

                    <DatepickerMui field={dataForm.startDate} onBlur={handleInputBlur} onChange={handleChangeInput} />
                </FormContainer>
            </Accordion>

            <Accordion title="Dados de beneficiário">
                <FormContainer>
                    <Input
                        field={dataForm.cpf}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                        loading={cpfLoading}
                    />
                    <Radio field={dataForm.nationality} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.fullName} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.socialName} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <DatepickerMui field={dataForm.birth} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Select field={dataForm.gender} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.motherName} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Select field={dataForm.civilState} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.pis} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.sus} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.dn} onBlur={handleInputBlur} onChange={handleChangeInput} />
                </FormContainer>
            </Accordion>

            <Accordion title="Dados de contato">
                <FormContainer>
                    <Input
                        field={{
                            ...dataForm.cep,
                            disabled: cepLoading,
                            loading: cepLoading,
                            icon: { name: 'search', type: 'round' },
                        }}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />

                    <EmptyField />

                    <Input
                        field={dataForm.address}
                        label="Endereço residencial"
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />
                    <Input field={dataForm.addressNumber} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.complement} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.hood} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Select field={dataForm.uf} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Select field={dataForm.city} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.cellphone} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.email} onBlur={handleInputBlur} onChange={handleChangeInput} />
                </FormContainer>
            </Accordion>

            <Accordion title="Documentos">
                <Alert
                    type={4}
                    title="Se você alterou algum dos dados abaixo, compartilhe com a gente um documento comprobatório:"
                    message="Data de admissão, nome do beneficiário, data de nascimento ou CPF"
                />

                <CardDocument
                    id={-1}
                    name="Documentos"
                    files={othersDocuments}
                    isOthers
                    onFileChange={(event) => handleFileChange({ event, id: -1, isOthers: true })}
                    onDeleteFile={handleFileDelete}
                    onClickViewFile={(dataFileClicked) => handleShowModal({ ...dataFileClicked })}
                />
                <S.AlignInfoTitular height={32} />
            </Accordion>

            <ContainerButton>
                <Button id="backStep" field={dataForm.backStep} type="secondary" onClick={() => history.goBack()}>
                    Voltar
                </Button>

                <Button
                    id="continueStep"
                    field={dataForm.continueStep}
                    type="primary"
                    loading={loadingPost}
                    onClick={handleSendDataTitular}
                    disabled={(otherDocumentsRequired && othersDocuments.length !== countFieldsChanged) || loadingPost}
                >
                    Finalizar
                </Button>
            </ContainerButton>

            <Modal
                title={modalInfo.title}
                subtitle={modalInfo.content}
                visible={showModal}
                modalSize="lg"
                onCancel={() => setShowModal(false)}
                footer={null}
            >
                {modalInfo.backButton && (
                    <Grid container direction="row" justifyContent="flex-end" alignItems="center">
                        <Button type="primary" onClick={() => setShowModal(false)}>
                            Voltar
                        </Button>
                    </Grid>
                )}
            </Modal>
            <PageLoader loading={pageLoading} />
        </PageContainer>
    );
}

export default Titular;
